// extracted by mini-css-extract-plugin
export var boxItems = "_80-1";
export var boxItemsLg = "_80-2";
export var button = "_80-7";
export var buttonLg = "_80-8";
export var filterGroupBox = "_80-0";
export var icon = "_80-3";
export var iconSecondary = "_80-6";
export var iconWrapper = "_80-4";
export var iconWrapperLg = "_80-5";